import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoFilledIcon } from '@sharedCR/coreDesignSystem/icons';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { IntentToProceedStatus } from '../../borrowersDelivery.constants';
import { BorrowersDeliveryStepTestIds } from '../../BorrowersDeliveryStep.testIds';

const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  padding: '18px 20px',
  borderRadius: '10px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  borderLeft: ({ palette }) => `3px solid ${palette.primary.main}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: ({ palette }) => palette.primary.main,
};

const bodyStyles = {
  color: ({ palette }) => palette.text.secondary,
};

const titleStyles = { color: ({ palette }) => palette.text.primary };

const chipWrapperStyles = { marginLeft: 'auto' };

const STATUS_CHIP = {
  [IntentToProceedStatus.NOT_YET_CAPTURED]: {
    title: 'NOT YET CAPTURED',
    variant: LabelVariant.GRAY,
  },
  [IntentToProceedStatus.CAPTURED]: { title: 'CAPTURED', variant: LabelVariant.GREEN },
};

const IntentToProceedCard = ({ status }) => {
  const chip = STATUS_CHIP[status] ?? STATUS_CHIP[IntentToProceedStatus.NOT_YET_CAPTURED];

  return (
    <Box data-testid={BorrowersDeliveryStepTestIds.INTENT_TO_PROCEED} sx={cardStyles}>
      <Box sx={headerStyles}>
        <InfoFilledIcon size={16} />
        <Typography sx={titleStyles} variant="bold14">
          Intent to Proceed
        </Typography>
        <Box sx={chipWrapperStyles}>
          <LabelCDS size="S" title={chip.title} variant={chip.variant} />
        </Box>
      </Box>
      <Typography sx={bodyStyles} variant="regular12">
        ITP will be requested <strong>after</strong> the borrower reviews this Loan Estimate. No
        fees other than a credit-report fee may be collected before Intent to Proceed is recorded.
        The captured value stamps to this LE version.
      </Typography>
    </Box>
  );
};

IntentToProceedCard.propTypes = {
  status: PropTypes.string,
};

export default memo(IntentToProceedCard);
